import {
  HouseContentsProductIntroFormValues,
  HouseContentsProductPriceFormValues,
} from "./houseContentsFormValuesInterfaces";

import { HouseContentsCoverage } from "Store/interfaces/products/coverage";
import { nullableFormBooleanToNullableBoolean } from "Utils/formUtils";

export const getInitialFormStateWithCorrectCoverage = (
  formState: HouseContentsProductPriceFormValues,
  standardCoverageOnly: boolean,
): HouseContentsProductPriceFormValues => {
  const correctCoverage = standardCoverageOnly
    ? HouseContentsCoverage.HOUSE_CONTENTS_STANDARD
    : formState.coverage;

  return {
    ...formState,
    coverage: correctCoverage,
  };
};

export const isFullRental = (
  values: HouseContentsProductIntroFormValues,
): boolean => {
  return nullableFormBooleanToNullableBoolean(values.fullRental) ?? false;
};
